const serviceLayout = () => {

}

module.exports = serviceLayout